
import Spinner from 'vux/src/components/spinner/index.vue'

import BScroll from 'better-scroll'
import Bubble from './Bubble.vue'
const DIRECTION_H = 'horizontal'
const DIRECTION_V = 'vertical'
export default {
components: {
Spinner,
Bubble,
},
props: {
/*
* 1 滚动的时候会派发scroll事件，会截流。
* 2 滚动的时候实时派发scroll事件，不会截流。
* 3 除了实时派发scroll事件，在swipe的情况下仍然能实时派发scroll事件
**/
probeType: {
type: Number,
default: 1,
},
/*
* 点击列表是否派发click事件
**/
click: {
type: Boolean,
default: true,
},
/*
* 是否派发滚动事件
**/
listenScroll: {
type: Boolean,
default: false,
},
/*
* 是否监听滚动之前，开启后才能派发beforeScrollStart事件
**/
listenBeforeScroll: {
type: Boolean,
default: false,
},
/*
* 滚动方向
* 可选值：horizontal、vertical
* 默认值：vertical
* */
direction: {
type: String,
default: DIRECTION_V,
},
/*
* 这个配置可以开启滚动条。
* 当设置为 true 或者是一个 Object 的时候，都会开启滚动条，默认开启
* 配置项：fade: （Boolean）,interactive: （Boolean）
* fade 为 true 表示当滚动停止的时候滚动条是否需要渐隐，interactive 表示滚动条是否可以交互
* 例：{
*       fade: true,
*       interactive: false // 1.8.0 新增
*     }
* */
scrollbar: {
type: null,
default: () => {
return {
fade: true,
}
},
},
/*
* 这个配置用于做下拉刷新功能。
* 当设置为 true 或者是一个 Object 的时候，可以开启下拉刷新。
* 可以配置顶部下拉的距离（threshold）来决定刷新时机以及回弹停留的距离（stop）
* 例pullDownRefresh: {
*     threshold: 50,
*     stop: 20
*   }
* 当下拉刷新数据加载完毕后，需要执行 finishPullDown 方法
* */
pullDownRefresh: {
type: null,
default: () => {
return {
threshold: 90,
stop: 40,
txt: '',
}
},
},
/*
* 这个配置用于做上拉加载功能。
* 当设置为 true 或者是一个 Object 的时候，可以开启上拉加载。
* 可以配置离底部距离阈值（threshold）来决定开始加载的时机
* 例：pullUpLoad: {
*      threshold: 50,
*      txt: {
more: '加载更多',
noMore: '没有更多数据了'
}
*     }
* */
pullUpLoad: {
type: null,
default: () => {
return {
threshold: 50,
txt: {
more: '',
noMore: '— 我是有底线的 —',
},
}
},
},
/*
* 纵轴方向初始化位置
* */
startY: {
type: Number,
default: 0,
},
/*
* 当数据更新后，刷新scroll的延时。
* */
refreshDelay: {
type: Number,
default: 20,
},
/*
* 有些场景我们需要支持横向和纵向同时滚动，而不仅限制在某个方向，
* 这个时候我们只要设置 freeScroll 为 true 即可
* */
freeScroll: {
type: Boolean,
default: false,
},
/*
* spinner类型，和vux类型一样
* */
spinnerType: {
type: String,
default: 'ios-small',
},
eventPassthrough: {
type: String,
default: DIRECTION_H,
},
},
data () {
return {
isPullup: false,
beforePullDown: true,
isRebounding: false,
isPullingDown: false,
pulling: false,
isPullUpLoad: false,
pullUpDirty: true, // 此变量用来检查是否加载到了最后一页
pullDownStyle: '',
bubbleY: 0,
reboundPullDownTimer: null,
afterPullDownTimer: null,
}
},
computed: {
pullUpTxt () {
const moreTxt = this.pullUpLoad && this.pullUpLoad.txt && this.pullUpLoad.txt.more
const noMoreTxt = (this.pullUpLoad && this.pullUpLoad.txt && this.pullUpLoad.txt.noMore) || '— 我是有底线的 —'
return this.pullUpDirty ? moreTxt : noMoreTxt
},
refreshTxt () {
return this.pullDownRefresh && this.pullDownRefresh.txt
},
},
watch: {
},
created () {
this.pullDownInitTop = -80
},
mounted () {
this.$nextTick(() => {
this.initScroll()
})
},
destroyed () {
this.scroll && this.scroll.destroy()
this.scroll = null
this.reboundPullDownTimer && clearTimeout(this.reboundPullDownTimer)
this.reboundPullDownTimer = null
this.afterPullDownTimer && clearTimeout(this.afterPullDownTimer)
this.afterPullDownTimer = null
},
methods: {
getStyle (obj, attr) {
if(obj.currentStyle) {
return obj.currentStyle[attr]
} else {
return document.defaultView.getComputedStyle(obj, null)[attr]
}
},
initScroll () {

if(!this.$refs.wrapper) {
return
}
const options = {
eventPassthrough: this.eventPassthrough,
probeType: this.probeType,
click: this.click,
scrollY: this.freeScroll || this.direction === DIRECTION_V,
scrollX: this.freeScroll || this.direction === DIRECTION_H,
scrollbar: this.scrollbar,
pullDownRefresh: this.pullDownRefresh,
pullUpLoad: this.pullUpLoad,
startY: this.startY,
freeScroll: this.freeScroll,
}

this.scroll = new BScroll(this.$refs.wrapper, options)
/*
* 触发时机：滚动过程中，具体时机取决于选项中的 probeType
* 触发事件在参数中需要开启 listenScroll
* */
if(this.listenScroll) {
this.scroll.on('scroll', (pos) => {
this.$emit('scroll', pos)
})
}
/*
* 触发时机：滚动开始之前 (触发事件在参数中需要开启 listenBeforeScroll )
* */
if(this.listenBeforeScroll) {
this.isPullup = false
this.scroll.on('beforeScrollStart', () => {
this.$emit('beforeScrollStart')
})
}
/*
* 触发时机：在一次下拉刷新的动作后，这个时机一般用来去后端请求数据。
* (触发事件在参数中需要开启 pullDownRefresh 相关配置 )
* */
if(this.pullDownRefresh) {
this.isPullup = false
this._initPullDownRefresh()
}
/*
* 触发时机：在一次上拉加载的动作后，这个时机一般用来去后端请求数据。
* (触发事件在参数中需要开启 pullingUp 相关配置 )
* */
if(this.pullUpLoad) {
this.isPullup = false
this._initPullUpLoad()
}
},
disable () {
this.scroll && this.scroll.disable()
},
enable () {
this.scroll && this.scroll.enable()
},
refresh () {
this.isPullup = false
this.scroll && this.scroll.refresh()
},
scrollTo (y) {
this.scroll && this.scroll.scrollTo(0, y)
},
scrollToElement () {
this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments)
},
destroy () {
this.scroll && this.scroll.destroy()
},

forceUpdate (dirty) {
this.$nextTick(() => {
this.pullUpDirty = dirty
if(this.pullDownRefresh && this.isPullingDown) {
this.pulling = false
this._reboundPullDown().then(() => {
this.isPullup = false
this._afterPullDown()
})
} else if(this.pullUpLoad) {
this.isPullUpLoad = false
this.scroll.finishPullUp()
this.refresh()
} else {
this.refresh()
}
})
},
_initPullDownRefresh () {
this.scroll.on('pullingDown', () => {
this.beforePullDown = false
this.isPullingDown = true
this.pulling = true
this.$emit('pullingDown')
})
this.scroll.on('scroll', (pos) => {
if(this.beforePullDown) {
this.bubbleY = Math.max(0, pos.y + this.pullDownInitTop)
let distance = Math.min(pos.y + this.pullDownInitTop, 10)
distance = distance < -80 ? -80 : distance
this.pullDownStyle = `top:${distance}px`
} else {
this.bubbleY = 0
}
if(this.isRebounding) {
this.pullDownStyle = `top:${10 - (this.pullDownRefresh.stop - pos.y)}px`
}
})
},
_initPullUpLoad () {
this.scroll.on('pullingUp', () => {
if(this.pullUpDirty) {
this.isPullUpLoad = true
this.$emit('pullingUp')
}
})
},
_reboundPullDown () {
const {stopTime = 600} = this.pullDownRefresh
return new Promise((resolve) => {
this.reboundPullDownTimer = setTimeout(() => {
this.isRebounding = true
this.isPullingDown = false
this.scroll.finishPullUp()
this.scroll.finishPullDown()
resolve()
}, stopTime)
})
},
_afterPullDown () {
this.isPullup = true

this.afterPullDownTimer = setTimeout(() => {
this.beforePullDown = true
this.isRebounding = false
this.refresh()
this.pullDownStyle = `top:-100px`
}, this.scroll.options.bounceTime)
},
},
}



// WEBPACK FOOTER //
// ./src/components/basic/scroll.vue